import React from 'react';
import { useIntl, defineMessages } from 'react-intl-next';

import { cssMap } from '@atlaskit/css';
import { token } from '@atlaskit/tokens';
import { Stack, Text, Flex } from '@atlaskit/primitives/compiled';

import { ContributorsOverflow } from '@confluence/content-history-new-contributors-overflow/entry-points/ContributorsOverflow';

import type { Editor } from './EditorsNameListComponent';

const i18n = defineMessages({
	editorsCount: {
		id: 'page-catchup.new-content-history-header.editors.count',
		defaultMessage: '{count, plural, one {1 person} other {{count} people}} edited these versions',
		description: 'Shows the number of people who edited the versions',
	},
});

const styles = cssMap({
	wrapper: {
		backgroundColor: token('color.background.neutral.subtle'),
		borderColor: token('color.border'),
		borderWidth: token('border.width'),
		borderStyle: 'solid',
		borderRadius: token('radius.small'),
		padding: token('space.200'),
	},
	textWrapper: {
		marginBottom: token('space.100'),
	},
});

export const NewContentHistoryContributorsAndHeader = ({ editors }: { editors: Editor[] }) => {
	const intl = useIntl();

	return (
		<Stack xcss={styles.wrapper} space="space.100">
			<Flex xcss={styles.textWrapper}>
				<Text color="color.text.subtle" weight="bold">
					{intl.formatMessage(i18n.editorsCount, { count: editors.length })}
				</Text>
			</Flex>
			<ContributorsOverflow contributors={editors} shouldUseGridStyles />
		</Stack>
	);
};
